"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var core_1 = require("@veeam/core");
var WizardActions_1 = require("../../WizardActions");
var WizardActionsViewController = /** @class */ (function (_super) {
    __extends(WizardActionsViewController, _super);
    function WizardActionsViewController() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WizardActionsViewController.prototype.present = function (state) {
        this.setState(state);
    };
    WizardActionsViewController.prototype.presentPending = function (_a) {
        var loading = _a.loading, pending = _a.pending;
        var prevState = this.getState();
        if (prevState) {
            this.setState(__assign(__assign({}, prevState), { loading: loading, pending: pending }));
        }
    };
    WizardActionsViewController.prototype.createElement = function (_a) {
        var _b, _c, _d, _e, _f;
        var loading = _a.loading, pending = _a.pending, actions = __rest(_a, ["loading", "pending"]);
        return (react_1.default.createElement(WizardActions_1.WizardActions, { loading: loading || pending, prev: {
                disabled: !actions.prev,
                didSelect: this.listener && this.listener.didSelectPrev.bind(this.listener),
                title: (_b = this.texts) === null || _b === void 0 ? void 0 : _b.actionPrev
            }, next: {
                disabled: !actions.next,
                didSelect: this.listener && this.listener.didSelectNext.bind(this.listener),
                title: (_c = this.texts) === null || _c === void 0 ? void 0 : _c.actionNext
            }, skip: {
                disabled: !actions.skip,
                didSelect: this.listener && this.listener.didSelectSkip.bind(this.listener),
                title: (_d = this.texts) === null || _d === void 0 ? void 0 : _d.actionSkip
            }, done: {
                disabled: !actions.done,
                didSelect: this.listener && this.listener.didSelectDone.bind(this.listener),
                title: (_e = this.texts) === null || _e === void 0 ? void 0 : _e.actionDone
            }, cancel: {
                disabled: !actions.cancel,
                didSelect: this.listener && this.listener.didSelectCancel.bind(this.listener),
                title: (_f = this.texts) === null || _f === void 0 ? void 0 : _f.actionCancel
            } }));
    };
    return WizardActionsViewController;
}(core_1.ReactViewController));
exports.WizardActionsViewController = WizardActionsViewController;
//# sourceMappingURL=WizardActionsViewController.js.map